import request from "@/utils/request";

export function login(param) {
  return request({
    url: "/api/login",
    method: "post",
    data: param,
    //useProgress: false,
    timeout: 60000,
  });
}
